import { Message } from '@dinosband/bv-messenger-schema'
import { BvDataCenterContext } from '../../'
import { DataCenter_StoreType } from '../abstract'
import { MyCommentMessages, LastCommentMessages } from '../comments-messages'
import { ChatRoomLastMessages } from './last-messages'

export class ChatRoomMessages extends DataCenter_StoreType<number, Message> {

  lastMessages: ChatRoomLastMessages
  myCommentMessages: MyCommentMessages
  lastCommentMessages: LastCommentMessages
  // messageLoadAgents: ChatRoomMessageLoadAgents


  constructor (context: BvDataCenterContext) {
    super(context)
    this.lastMessages = new ChatRoomLastMessages(context)
    this.myCommentMessages = new MyCommentMessages(context)
    this.lastCommentMessages = new LastCommentMessages(context)
    // this.messageLoadAgents = new ChatRoomMessageLoadAgents(context)
  }

  async init () {
    await this.lastMessages.init()
    await this.myCommentMessages.init()
    await this.lastCommentMessages.init()
    // await this.messageLoadAgents.init()
  }

  cleanup () {
    // this.messageLoadAgents.cleanup()
    super.cleanup()
    this.lastMessages.cleanup()
    this.myCommentMessages.cleanup()
    this.lastCommentMessages.cleanup()
  }

  // LastMessages
  lastMessage (chatRoomId: number) {
    return this.lastMessages.lastMessage(chatRoomId)
  }
  lastValidMessage (chatRoomId: number) {
    return this.lastMessages.lastValidMessage(chatRoomId)
  }
  lastUpdatedMessage (chatRoomId: number) {
    return this.lastMessages.lastUpdatedMessage(chatRoomId)
  }
  async initChatRooms (chatRoomIds: number[], channelId?: number) {
    await this.lastMessages.initChatRooms(chatRoomIds, channelId)
  }
  cleanupChannel (channelId: number) {
    this.lastMessages.cleanupChannel(channelId)
  }

  onReconnected () {
    this.lastMessages.onReconnected()
  }

}